<template>
    <div>
        <div class="selector">
            <div class="item-bar" ref="item-bar">
                <div
                    v-for="(application, index) in applications"
                    :key="application.id"
                    class="item"
                    :class="{
                        active: activeApplicationIndex == index && applicationDialogActive ,
                        enabled: application.active
                    }"
                    :style="[application.image.length ? {'background-image': 'url(' + application.image[0].url + ')'} : {}]"
                    @click="showApplicationDialog(index)"
                >
                    {{ application.title }}
                </div>
            </div>
            <div class="preview" ref="preview">
                <classroom ref="classroom"></classroom>
            </div>
            <applicationDialog
                v-if="applicationDialogActive"
                :application="applications[activeApplicationIndex]"
                @close="hideApplicationDialog()"
                @toggle="toggleApplication()"
                @usage="showUsageDialog()"
            ></applicationDialog>
            <popup v-if="usageDialogActive" @close="hideUsageDialog()" :title="applications[activeApplicationIndex].title">
                <div class="grid">
                    <div class="col-7" v-html="applications[activeApplicationIndex].usage">
                    </div>
                    <div class="col-5">
                        <img :src="applications[activeApplicationIndex].image.length ? applications[activeApplicationIndex].image[0].url : '' ">
                    </div>
                </div>
            </popup>
        </div>
        <div class="u-mt--small u-right">
            <button class="button button--large bt-mg" @click="reset">Zurücksetzen</button>
            <button class="button button--large" @click="$emit('next')">{{ $t('to the summary') }}<i class="fas fa-chevron-right"></i></button>
        </div>
    </div>
</template>

<script>
    import applicationDialog from './applicationDialog'
    import popup from '../../Popup'
    import classroom from './classroom'

    export default {
        components: {
            applicationDialog,
            popup,
            classroom
        },
        data: function(){
            return {
                applicationDialogActive: false,
                usageDialogActive: false,
                activeApplicationIndex: null,
                intervalId: -1,
            }
        },
        methods: {
            showApplicationDialog(index){
                this.applicationDialogActive = true
                this.activeApplicationIndex = index
            },
            hideApplicationDialog(){
                this.applicationDialogActive = false
            },
            showUsageDialog(){
                this.usageDialogActive = true
            },
            hideUsageDialog(){
                this.usageDialogActive = false
            },
            // Enables or disalbes the provided application and enables or disables asocciated technologies
            toggleApplication(){
                if(!this.applications[this.activeApplicationIndex].active){
                    this.$store.dispatch('configurator/enableApplication', this.applications[this.activeApplicationIndex].id)
                } else {
                    this.$store.dispatch('configurator/disableApplication', this.applications[this.activeApplicationIndex].id)
                }
                this.hideApplicationDialog()
                this.$refs['classroom'].$forceUpdate()
            },
            reset() {
                this.$refs['classroom'].resetTechnologies()
                this.applications.forEach((el) => {
                    this.$store.dispatch('configurator/disableApplication', el.id)
                })
                this.$refs['classroom'].$forceUpdate()
            },
            updateHeight(){
              if(screen.width > 500) {
                this.$refs['item-bar'].style.maxHeight = this.$refs['preview'].offsetHeight + "px"
              }
              return true;
            }
        },
        computed: {
            applications(){
                return this.$store.getters['configurator/getApplications']
            },
            technologies(){
                return this.$store.getters['configurator/getTechnologies']
            }
        },
        mounted: function() {
          this.updateHeight()
        },
    }
</script>

<style scoped lang="scss">

    .selector {
        display: grid;
        grid-template-columns: 2fr 5fr;
        grid-gap: 30px;
        padding-top: 50px;

        &>.card {
            position: absolute;
            top: 44vh;
            right: 22vw;
            width: 680px;
            z-index: 10;
        }
    }

    .item-bar {
        padding-right: 20px;
        position: relative;
        max-height: 60vh;
        overflow-y: scroll;
        overflow-x: hidden;

        .item {
            width: 100%;
            border: 1px solid $blue;
            margin-bottom: 15px;
            padding: 25px 25px 25px 90px;
            font-weight: 600;
            background-size: 70px;
            background-position: left 5px center;
            background-repeat: no-repeat;
            cursor: pointer;
            transition: background-color 0.3s ease;
        }
        .item:hover {
            background-color: $lightgrey;
        }
        .item.enabled {
            background-color: $orange;
            color: $white;
        }
        .item.active {
            background-color: $blue;
            color: $white;
        }
    }

    .preview {
        position: relative;
        border: 1px solid $blue;
        background-color: #D9D4EB;
        height: fit-content;
    }

    @media (min-width: 1700px){
      .selector {
        width: 1600px;
        margin: 0 auto;
      }
    }

    @media (max-width: 1300px){
        .selector {
          display: grid;
          grid-template-columns: 3fr 4fr;
        }
    }
    @media (max-width: 1175px){

        .selector {
            grid-template-columns: 1fr;
            padding: 0;

            &>.card {
                top: 25vh;
                right: 0;
                left: 0;
                margin: 0 auto;
                width: 90%;
                position: fixed;

                &__content {
                    overflow-y: scroll;
                    overflow-x: hidden;
                    height: 60vh;
                }
            }
        }

        .item-bar {
            max-height: 40vh;
            padding: 0;
        }
        .item-bar::-webkit-scrollbar {
            display: none;
        }
    }

    @media (max-width: 950px){
        .item-bar {
            &>.card {
                width: 450px;
                right: -480px;
            }
        }
    }

    @media (max-width: 500px) {
        .preview {
          display: none;
        }
    }
</style>
